<div
  class="product"
  [ngClass]="{
    'product--shipyard': product.name === 'Shipyard',
    'product--priceyard': product.name === 'Priceyard',
    'product--planyard': product.name === 'Planyard',
    'product--netyard': product.name === 'Netyard',
    'active_product' : isOnBoarding && currentTier
  }"
>
  <div class="product_banner" *ngIf="product.comingSoon"></div>
  <div class="product_header">
    <div
      class="product_icon"
      [style.backgroundImage]="
        'url(assets/images/application-icons/' +
        product.name.toLowerCase() +
        '-icon.svg)'
      "
    ></div>
    <div class="product_title">{{ product.name }}</div>
    <span class="product_description">{{ product.description }}</span>
  </div>
 <!-- <div class="product_headerDesc">
    {{ product.name }} can make your business easy.
  </div>-->
  <div class="product_selected" *ngIf="product.tiers[tierIndex]">
    <div class="product_info-label">Currently using</div>
    <div class="product_info-label product_info-label--right">
      Up to {{ product.tiers[tierIndex].upto == -1 ? "Unlimited" : (product.tiers[tierIndex]?.upto | number) }} {{product.denominator}}
    </div>
    <div class="product_info-value">
      {{ product.tiers[tierIndex]?.name }}
    </div>
    <div class="product_info-value product_info-value--right">
      {{ product.tiers[tierIndex]?.price ? "$" : "" }}
      {{ product.tiers[tierIndex]?.price}}
    </div>
    <div class="product_selected-divider"></div>
    <!--<div class="product_info-label product_info-label--right fullWidth">
      Product <span>$400.00</span>
    </div>
    <div class="product_info-label product_info-label--right fullWidth">
      Additional Integration <span>$100.00</span>
    </div>-->
    <div class="fullWidth text-center mt-2">
      <span class="hand text-primary" (click)="columnVisible(product.name,'edit')">Edit Tier</span>
    </div>
  </div>
  <div class="product_action">
    <div class="add-btn" *ngIf="!currentTier" [class.disabled]="product.comingSoon" (click)="columnVisible(product.name,'edit')">Add to yard</div>
    <div class="remove-btn" *ngIf="currentTier" (click)="removeFromYard(product)">Remove from yard</div>
  </div>
  <!-- <div #toggleExplore class="product_explore pointer" (click)="columnVisible(product.name)">
    <img src="../../../../assets/images/arrow-down-circle.png" alt="" class="mb-1 me-1">Explore Details
  </div> -->
  <!-- <div class="product_ribbon">
    <span>COMING SOON</span>
  </div> -->
</div>
<div class="product-detail-dialog" *ngIf="product.visible" #menu>
  <div
  class="product product-dialog"
  [ngClass]="{
    'product--shipyard': product.name === 'Shipyard',
    'product--priceyard': product.name === 'Priceyard',
    'product--planyard': product.name === 'Planyard',
    'product--netyard': product.name === 'Netyard'
  }"
>
  <div class="product_banner" *ngIf="product.comingSoon"></div>
  <div class="product_header">
    <div
      class="product_icon"
      [style.backgroundImage]="
        'url(assets/images/application-icons/' +
        product.name.toLowerCase() +
        '-icon.svg)'
      "
    ></div>
    <div>
      <span class="product_description">{{ product.description }}</span>
      <div class="product_title">{{ product.name }}</div>
    </div>
  </div>
  <!-- <div class="product_selected" *ngIf="product.tiers[tierIndex]">
    <div class="product_info-label">Currently using</div>
    <div class="product_info-label product_info-label--right">
      Up to {{ product.tiers[tierIndex].upto == -1 ? "Unlimited" : (product.tiers[tierIndex].upto | number) }} {{product.denominator}}
    </div>
    <div class="product_info-value">
      {{ product.tiers[tierIndex].name }}
    </div>
    <div class="product_info-value product_info-value--right">
      {{ product.tiers[tierIndex].price ? "$" : "" }}
      {{ product.tiers[tierIndex].price }}
    </div>
  </div> -->

  <div class="product_body">
    <ul class="product_features custom-scrollv2">
      <li class="product_listTitle d-flex align-items-center">Features
        <div class="ms-auto" *ngIf="product?.remainingTrialDays > 0">
          <span class="gray-text">Trial Days Left :</span> {{product?.remainingTrialDays | number}}
        </div>
      </li>
      <li class="feature" *ngFor="let feature of features; let i = index">
        <div class="feature_text">{{ feature.name }}</div>
        <div class="feature_value">
          <i *ngIf="feature.value === 'Included'" class="fal fa-check-circle"></i>
          <span *ngIf="feature.value !== 'Included'">{{ feature.value }}</span>
        </div>
      </li>
    </ul>
    <mat-radio-group class="selection" [formControl]="tierControl">
      <div class="selection_title">Monthly {{product.denominator}} limit</div>
        <ng-container *ngFor="let tier of product.tiers">
          <mat-radio-button
            [value]="tier.tierId"
            [checked]="tier.isSelected"
            [disabled]="isCurrentProduct && (orderCount > tier.upto && tier.upto !== -1) || product.comingSoon"
          >
            <div class="selection_item">
              <div class="selection_option">
                <div class="selection_tier">
                  <span class="selection_name" [ngClass]="{'selection_name--freemium': tier.name == 'Freemium'}">{{ tier.name }}</span>
                  <span class="current-tag" *ngIf="tier.currentSelected"
                    >Current </span
                  >
                  <span class="current-tag upgrade" *ngIf="(!tier.currentSelected && tier.name == 'Premium' && tierIndex !== -1 && !isOnBoarding)"
                  >Upgrade</span
                >
                </div>
                <div class="selection_orders" *ngIf="tier.upto != 1">
                  {{ tier.upto == -1 ? "Unlimited" : (tier.upto | number) }}
                  {{product.denominator}}
                </div>
                <div class="selection_orders" *ngIf="tier.upto == 1">
                  Pay per Shipment
                </div>
              </div>
              <div class="selection_price">
                <span>{{ tier.price == 0 ? "Free" : "$" + tier.price }}</span>
              </div>
            </div>
          </mat-radio-button>
        </ng-container>
    </mat-radio-group>
  </div>
  <div class="product_action">
    <div class="product_button">
      <app-button [buttonStyle]="'underline'" (click)="cancel()"
        >Cancel</app-button
      >
    </div>
    <div class="product_button" *ngIf="showProduct">
      <app-button (click)="add()">Select </app-button>
    </div>
    <app-button
      *ngIf="!currentTier && !showProduct"
      (click)="addToYard()"
      [isDisabled]="product.comingSoon"
      >Add to yard</app-button
    >
    <div class="product_button" *ngIf="currentTier && !showProduct">
      <app-button (click)="removeFromYard(product)"
        >Remove from yard</app-button
      >
    </div>
    </div>
  </div>

